import { PIdNameModel } from '../projects/types';

export const MAX_COST_AMOUNT = 999999999999999;
export const MIN_COST_AMOUNT = 1;
export const MAX_COST_FILES_COUNT = 10;

export const ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'xlsx', 'pdf'];

export interface CostReportItem {
    id: number;
    employeeId: number;
    employeeName: string
    date: string;
    projectId?: number;
    projectName?: string;
    note?: string;
    amount: number;
    files?: FileMetadata[];
}

export interface FileMetadata {
    id: number;
    employeeId: number;
    name: string;
    storageName: string;
    urlName: string;
    extension: FileExtension;
    date: string;
    fileDownloadUrl: string; 
}

export enum FileExtension {
    Unsupported = -1,
    Png = 0,
    Pdf = 1,
    Xlsx = 2,
    Jpg = 3,
}
export const getFileExtension = (type: FileExtension) => {
    switch (type) {
        case FileExtension.Pdf: return 'pdf';
        case FileExtension.Jpg: return 'jpg';
        case FileExtension.Png: return 'png';
        case FileExtension.Xlsx: return 'xlsx';
        default: return '';
    }
};

export type Cost = {
    id: number;
    employeeId: number;
    date: string;
    note?: string;
    amount: number;
    projectId?: number;
    files?: FileMetadata[];
}

export type CostToCreate = {
    id: number;
    employeeId: number;
    date: string;
    note?: string;
    amount: number;
    projectId?: number;
    files?: File[];
}

export type CostToEdit = {
    id: number;
    employeeId: number;
    date: string;
    note?: string;
    amount: number;
    projectId?: number;
    files?: File[];
    removedFileIds?: number[];
}

export function CreateEmptyCostReportItemByEmployee(
    employeeId: number, 
    employeeName: string): CostReportItem {
    return ({
        id: -1,
        employeeId: employeeId,
        employeeName: employeeName,
        date: '',
        note: '', 
        amount: 0,
        projectId: undefined,
        projectName: undefined,
        files: []
    });
}

export function CreateCostReportItemByCost(
    employeeId: number, 
    employeeName: string,
    cost: Cost,
    projects?: PIdNameModel[]): CostReportItem {
    return ({
        id: cost.id,
        employeeId: employeeId,
        employeeName: employeeName,
        date: cost.date,
        note: cost.note,
        amount: cost.amount,
        projectId: cost.projectId,
        projectName: cost.projectId && projects ? projects?.find(x => x.id == cost.projectId)?.name : '',
        files: cost.files
    });
}

